// extracted by mini-css-extract-plugin
module.exports =  {"text-align-center":"_2787e5dfdf--text-align-center--wS6Cz","text-align-right":"_2787e5dfdf--text-align-right--EMFbI"};